// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutualFollowersModal_footer__Q0Bga","mutual-followers-list":"MutualFollowersModal_mutual-followers-list__2NnI2"};